import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Ecosystem from "@/pages/Ecosystem";

export const Route = createFileRoute("/zh-cn/about-qbd/ecosystem")({
  head: () => buildRouteHead("/zh-cn/about-qbd/ecosystem"),
  component: Ecosystem,
});

